// vNext context-based modal types
export const CANCEL_PTR = 'CANCEL_PTR';
export const CANCEL_ADDON = 'CANCEL_ADDON';
export const REACTIVATE_PTR = 'REACTIVATE_PTR';
export const REACTIVATE_SUBSCRIPTION = 'REACTIVATE_SUBSCRIPTION';
export const QUIT_SHARING = 'QUIT_SHARING';
export const DELETE_INVITE = 'DELETE_INVITE';
export const SHARING_ACCEPT_SUCCESS = 'SHARING_ACCEPT_SUCCESS';
export const ACTION_REQUIRED = 'ACTION_REQUIRED';
export const DELIVERY_DELETION = 'DELIVERY_DELETION';

export const vNextModals = [
    CANCEL_PTR,
    CANCEL_ADDON,
    REACTIVATE_PTR,
    REACTIVATE_SUBSCRIPTION,
    QUIT_SHARING,
    DELETE_INVITE,
    SHARING_ACCEPT_SUCCESS,
    ACTION_REQUIRED,
    DELIVERY_DELETION,
];
